import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Drawer,
  FormControl,
  FormControlLabel,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const ChooseFilter = ({
  title,
  filter,
  checkedItems = [],
  onSelect,
  clearFilter,
}) => {
  const allItems = useSelector((state) => state?.static[filter.staticName]);
  const [options, setOptions] = useState([]);

  const handleChange = (code) => {
    onSelect(title, code);
  };

  const handleChangeSelect = async (value, reason) => {
    if (reason === 'clear') {
      clearFilter(title);
      return;
    }
    if (reason === 'removeOption') {
      const tmp = checkedItems.find((option) => !value.includes(option)); // trouver l'option à supprimer
      onSelect(title, { name: tmp }); // Le rajouter aux options choisie car: 2 fois la même option => suppression de l'option
      return;
    }
    value.forEach((newValue) => onSelect(title, newValue));
  };

  useEffect(() => {
    const items = [];
    allItems?.map((item) => {
      filter?.defaultList.includes(item.code) ||
      filter?.defaultList.includes(item.name)
        ? items.push(item)
        : null;
    });
    setOptions(items);
    if (filter?.defaultList?.length < 1) {
      setOptions(allItems);
    }
  }, [allItems, filter?.defaultList]);

  // Si c'est un filtre de marque, utiliser le Select multiple
  if (filter.staticName === 'brand' || filter.staticName === 'stores') {
    return (
      <Box
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ padding: 2 }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormControl sx={{ m: 1, width: '100%', padding: 1 }}>
            <Autocomplete
              id={`multiple-chip-${filter.staticName}`}
              multiple
              disableCloseOnSelect
              value={checkedItems}
              options={options || []}
              getOptionLabel={(option) =>
                option?.code || option?.name || option
              }
              getOptionKey={(option) => option?._id}
              onChange={(e, value, reason) => handleChangeSelect(value, reason)}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </Box>
      </Box>
    );
  }

  // Pour les autres filtres, garder le comportement existant
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ListSubheader component="div">{title}</ListSubheader>
      <Box
        sx={{
          ml: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {options?.map((item) => {
          // Si pas de codes on change les filtres qu'on envoie au back avec les names
          return (
            <ListItem
              disablePadding
              sx={{
                py: 0.5,
              }}
              key={`list-item-${item._id}`}
            >
              <ListItemButton
                onClick={() => handleChange(item)}
                sx={{
                  minHeight: 32,
                  padding: '4px 8px',
                }}
                key={`list-button-${item._id}`}
              >
                <ListItemIcon
                  sx={{
                    minWidth: '32px',
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <FormControlLabel
                    key={`checkbox-${item._id}`}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          checkedItems.includes(item?.code) ||
                          checkedItems.includes(item?.name)
                        }
                      />
                    }
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.name}
                  slotProps={{
                    primary: {
                      style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '0.875rem',
                      },
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </Box>
    </Box>
  );
};

const FiltersDrawer = ({ updateFilter, filters = [], clearFilter }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box>
      {/* Bouton d'ouverture des filtres */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => setIsOpen(true)}
        sx={{ marginBottom: 2, marginRight: 2 }}
      >
        Ouvrir les filtres
      </Button>
      {/* Drawer pour les filtres */}
      <Drawer
        sx={{
          width: 300,
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Box
          sx={{
            width: 500,
            padding: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          {/* Conteneur scrollable pour les filtres */}
          <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
            {filters.map((filter, index) => (
              <ChooseFilter
                key={index}
                title={filter.label}
                filter={filter}
                checkedItems={filter.checkedItems}
                onSelect={updateFilter}
                clearFilter={clearFilter}
              />
            ))}
          </Box>
          {/* Bouton Fermer en bas */}
          <Button
            onClick={() => setIsOpen(false)}
            sx={{
              marginTop: 'auto',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
            variant="contained"
            color="info"
            startIcon={<CloseIcon />}
          >
            Fermer
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
};

export default FiltersDrawer;
